<div [ngClass]="[titleText?.color | prefix:'text', primaryColor | prefix:'bg']" class="item space-y-4 p-8 rounded-lg">
  <div *ngIf="date" class="date">{{date}}</div>
  <div class="title">{{title}}</div>
  <div *ngIf="perex" class="subtitle">{{perex}}</div>
</div>
